import React from "react";
import { Search } from "lucide-react";

export interface SearchModalProps {
  children: React.ReactNode;
  handleSearch: () => void;
  searchButtonText: string;
  modalIdentifier: string;
}

export function SearchModal({
  children,
  handleSearch,
  searchButtonText,
  modalIdentifier,
}: SearchModalProps) {
  return (
    <>
      <div className="fixed inset-0 z-30 bg-black/50 backdrop-blur-xs" />
      <div className="absolute top-full left-1/2 z-40 mt-2 w-screen -translate-x-1/2 px-4 md:max-w-2xl md:px-0">
        <div
          className={`${modalIdentifier} bg-soluud-background-card border-soluud-border animate-[menu-enter_150ms_ease-out] overflow-hidden rounded-xl border shadow-[--shadow-elevated]`}
        >
          <div className="space-y-6 p-4">
            <div className="relative">
              {children}
              <div className="border-soluud-border-subtle mt-2 border-t pt-4">
                <button
                  onClick={handleSearch}
                  className="bg-soluud-primary hover:bg-soluud-primary-hover active:bg-soluud-primary-active text-soluud-text-light focus-visible:ring-soluud-primary flex w-full items-center justify-center space-x-2 rounded-xl px-6 py-3.5 text-sm font-semibold shadow-sm transition-all duration-150 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none active:scale-[0.98]"
                >
                  <Search className="h-5 w-5" />
                  <span>{searchButtonText}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
